import { Component } from "react";
import "./PageForm.css";
import TalaeraSpinner from "./../../TalaeraSpinner/TalaeraSpinner";
import logoImg from "./../../../images/talaera-logo-white.svg";
import { getErrorComponents } from "./../../../services/util";

export default class PageForm extends Component {
  render() {
    const mode = this.props.mode || "form";
    let childComponent = null;
    if (mode === "form") {
      childComponent = <AppPanelForm {...this.props} />;
    } else {
      childComponent = <div className="inner-container">{this.props.children}</div>;
    }

    return (
      <div
        className={
          "app-panel-wrapper" +
          (this.props.wrapperClassName ? " " + this.props.wrapperClassName : "")
        }
      >
        <div className={"app-panel " + this.props.className}>
          <div>
            {this.props.withLogo && (
              <div className="logo-container">
                <a id="logo-image" href="//talaera.com">
                  <img src={logoImg} alt="Talaera logo" />
                </a>
              </div>
            )}
            {this.props.topBorder && <div className="top-border"></div>}
            <div className="content">
              <div className="inner">
                {this.props.titleComponent}

                {this.props.showSpinner && (
                  <div className="spinner-container">
                    <TalaeraSpinner />
                  </div>
                )}
                {childComponent}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class AppPanelForm extends Component {
  render() {
    const isValid = this.props.isValidForm;
    let formClassName = this.props.formClassName;
    if (!isValid) {
      formClassName += " invalid";
    }

    let actionsName = "actions";
    if (this.props.verticalActions) {
      actionsName += " nofloat";
    }

    return (
      <div
        className={
          this.props.showSpinner ? "form-container spinner-form" : "form-container"
        }
      >
        <form className={formClassName} onSubmit={this.props.onFormSubmitted}>
          <div className="form-fields">{this.props.children}</div>
          {this.props.errors && getErrorComponents(this.props.errors)}
          <div className="form-actions">
            <div className={actionsName}>{this.props.formActions}</div>
          </div>
        </form>
      </div>
    );
  }
}
